import type { EntitlementPlan, PaidFeatureId } from "./paid-features";

export type CheckoutPlanId = Exclude<EntitlementPlan, "free">;

export interface CheckoutSessionRequest {
  plan: CheckoutPlanId;
  successUrl: string;
  cancelUrl: string;
  installId: string;
  metadataPolicy: "no_document_contents";
}

export interface CheckoutEntitlementGrant {
  plan: CheckoutPlanId;
  source: "verified_checkout";
  provider: string;
  providerCustomerId: string;
  providerPurchaseId: string;
  features: PaidFeatureId[];
  issuedAt: string;
  expiresAt?: string;
}

export const PAID_PLAN_FEATURES: Record<CheckoutPlanId, PaidFeatureId[]> = {
  monthly: [
    "bulkOutput",
    "premiumDesigns",
    "advancedEditor",
    "multipleBrandKits",
    "brandKitStyling",
    "unlimitedBusinessTemplates",
    "designPacks",
  ],
  lifetime: [
    "bulkOutput",
    "premiumDesigns",
    "advancedEditor",
    "multipleBrandKits",
    "brandKitStyling",
    "unlimitedBusinessTemplates",
    "designPacks",
  ],
};

export const CHECKOUT_CONTRACT_RULES = [
  "Checkout session metadata must not include seller, customer, item, spreadsheet, PDF, XML, ZIP, or invoice contents",
  "Webhook events must be signature-verified before creating entitlement grants",
  "Webhook processing must be idempotent by provider event id",
  "Monthly and Lifetime grant the same paid feature set",
  "Monthly grants must include a provider-verified period end or refresh proof before unlock",
  "Restore must use provider customer or portal state, not browser-local trust alone",
  "Refund or cancellation must revoke or expire paid feature grants through verified provider events",
];

export function checkoutFeaturesForPlan(plan: CheckoutPlanId): PaidFeatureId[] {
  return [...PAID_PLAN_FEATURES[plan]];
}
